import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import React, { useState, useRef, lazy, Suspense } from 'react';
import { useIntl, defineMessages } from 'react-intl-next';
import { useForm, AkForm, isActionButton, FormContext } from '../form';
import { useButton, useActionButtons } from '../button/Button';
export var AkModalDialog = /*#__PURE__*/lazy(function () {
  return import('@atlaskit/modal-dialog');
});
var AKModalHeader = /*#__PURE__*/lazy(function () {
  return import('@atlaskit/modal-dialog/modal-header');
});
var AKModalTitle = /*#__PURE__*/lazy(function () {
  return import('@atlaskit/modal-dialog/modal-title');
});
var AKModalBody = /*#__PURE__*/lazy(function () {
  return import('@atlaskit/modal-dialog/modal-body');
});
var AKModalFooter = /*#__PURE__*/lazy(function () {
  return import('@atlaskit/modal-dialog/modal-footer');
});
var AKButton = /*#__PURE__*/lazy(function () {
  return import('@atlaskit/button/loading-button');
});
var COMPONENT_TOP_MARGIN = "var(--ds-space-150, 12px)";
function applyTopMargin(element) {
  return jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: css({
      marginTop: COMPONENT_TOP_MARGIN
    })
  }, element);
}
export function useModalDialog(_ref) {
  var forgeDoc = _ref.forgeDoc,
    dispatch = _ref.dispatch,
    render = _ref.render;
  var intl = useIntl();
  var _ref2 = forgeDoc.props || {},
    appearance = _ref2.appearance,
    header = _ref2.header,
    onClose = _ref2.onClose,
    _ref2$closeButtonText = _ref2.closeButtonText,
    closeButtonText = _ref2$closeButtonText === void 0 ? intl.formatMessage(messages.closeModalButton) : _ref2$closeButtonText,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 'medium' : _ref2$width;
  var formForgeDoc = forgeDoc.children.length === 1 && forgeDoc.children[0].type === 'Form' ? forgeDoc.children[0] : undefined;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isClosing = _useState4[0],
    setIsClosing = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    formValues = _useState6[0],
    setFormValues = _useState6[1];
  var setFormValue = function setFormValue(name, value) {
    setFormValues(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, value));
    });
  };
  var _useForm = useForm({
      // This is awkward because we only use values if formForgeDoc exists
      // I want to conditionally call this hook but I can't
      forgeDoc: formForgeDoc || {
        type: 'Form',
        children: []
      },
      dispatch: dispatch,
      render: render
    }),
    children = _useForm.children,
    akFormProps = _useForm.akFormProps,
    htmlFormProps = _useForm.htmlFormProps,
    akFormSubmitButtonProps = _useForm.akSubmitButtonProps;
  var akFormPropsWithOnSubmit = _objectSpread(_objectSpread({}, akFormProps), {}, {
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              _context.prev = 1;
              _context.next = 4;
              return akFormProps.onSubmit.apply(akFormProps, _args);
            case 4:
              _context.prev = 4;
              setIsSubmitting(false);
              return _context.finish(4);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1,, 4, 7]]);
      }));
      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  });
  var formId = useRef("modal-form-id-".concat(Date.now()));
  var akSubmitButtonProps = _objectSpread(_objectSpread({}, akFormSubmitButtonProps), {}, {
    appearance: appearance || 'primary',
    isLoading: isSubmitting,
    form: formId.current
  });
  var handleClose = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsClosing(true);
            _context2.prev = 1;
            _context2.next = 4;
            return dispatch({
              type: 'event',
              handler: onClose,
              args: [],
              extensionData: {}
            });
          case 4:
            _context2.prev = 4;
            setIsClosing(false);
            return _context2.finish(4);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1,, 4, 7]]);
    }));
    return function handleClose() {
      return _ref3.apply(this, arguments);
    };
  }();
  var actions = formForgeDoc ? formForgeDoc.children.filter(isActionButton) : [];
  var _useActionButtons = useActionButtons({
      forgeDoc: actions,
      dispatch: dispatch,
      render: render
    }),
    akActionButtonProps = _useActionButtons.akActionButtonProps;
  var _useButton = useButton({
      forgeDoc: {
        type: 'Button',
        props: {
          appearance: 'subtle',
          text: closeButtonText,
          onClick: onClose
        },
        children: []
      },
      dispatch: dispatch,
      render: render
    }),
    closeButtonProps = _useButton.akButtonProps;
  var akCloseButtonProps = _objectSpread(_objectSpread({}, closeButtonProps), {}, {
    isLoading: isClosing || closeButtonProps.isLoading
  });
  return {
    akModalDialogProps: {
      onClose: handleClose,
      width: width
    },
    akModalTitleProps: {
      appearance: appearance,
      children: header
    },
    akModalBodyProps: {
      children: formForgeDoc ? jsx(AkForm, akFormPropsWithOnSubmit, function (_ref4) {
        var formProps = _ref4.formProps;
        return jsx("form", _extends({}, formProps, htmlFormProps, {
          id: formId.current
        }), jsx(FormContext.Provider, {
          value: {
            formValues: formValues,
            setFormValue: setFormValue
          }
        }, React.Children.map(children, function (child, index) {
          return index === 0 ? child : applyTopMargin(child);
        })));
      }) : React.Children.map(forgeDoc.children.map(render), function (child, index) {
        return index === 0 ? child : applyTopMargin(child);
      })
    },
    actions: formForgeDoc ? [].concat(_toConsumableArray(akActionButtonProps), [akCloseButtonProps, akSubmitButtonProps]) : [akCloseButtonProps]
  };
}
export function ModalDialog(props) {
  var _useModalDialog = useModalDialog(props),
    akModalDialogProps = _useModalDialog.akModalDialogProps,
    akModalTitleProps = _useModalDialog.akModalTitleProps,
    akModalBodyProps = _useModalDialog.akModalBodyProps,
    actions = _useModalDialog.actions;
  return jsx(Suspense, {
    fallback: null
  }, jsx(AkModalDialog, akModalDialogProps, jsx(AKModalHeader, null, jsx(AKModalTitle, akModalTitleProps)), jsx(AKModalBody, akModalBodyProps), jsx(AKModalFooter, null, actions.map(function (akButtonProps, index) {
    return jsx(AKButton, _extends({}, akButtonProps, {
      key: index
    }));
  }))));
}
var messages = defineMessages({
  closeModalButton: {
    id: 'confluence.modal.dialog.close.modal.button',
    defaultMessage: 'Cancel',
    description: 'The text inside of the button that will cancel the modal operation.'
  }
});